import { useMutation } from "@apollo/client/react";
import { DSModal } from "@components/design-system/organisms";
import mixpanel from "mixpanel-browser";
import moment from "moment";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";

import { APPEND_RECORDING } from "../../notes/edit/api/mutations";
import { alert } from "../Alert";
import Record from "../record/Record";

export default function RecordingModal({
  shouldShow,
  setShouldShow,
  isForEditNote,
  noteUuid,
}) {
  const [isRecording, setIsRecording] = useState(false);
  const { control, getValues } = useForm();
  const [appendRecording] = useMutation(APPEND_RECORDING);

  const navigate = useNavigate();

  async function appendRecordingToNote(
    audioStorageLink,
    storageObjectName,
  ) {
    appendRecording({
      variables: {
        noteUuid: noteUuid,
        storageObjectName: storageObjectName,
        createdAt: moment().format(),
        lastUpdatedAt: moment().format(),
      },
    })
      .then(() => {
        mixpanel.track("Appended Recording to Note");
        if (isForEditNote) {
          alert(
            "success",
            "Audio file uploaded! Taking you back to the dashboard...",
          );
          setTimeout(function () {
            navigate("/dashboard");
          }, 1000);
        } else {
          alert("success", "Audio file uploaded!");
          setTimeout(function () {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((e) => {
        alert("error", e.message);
        setTimeout(function () {
          navigate("/dashboard");
        }, 1000);
      });
  }

  const handleClose = () => {
    if (!isRecording) {
      setShouldShow(false);
    }
  };

  return (
    <DSModal
      isOpen={shouldShow}
      onClose={handleClose}
      title="Add to Recording"
      actions={
        isRecording
          ? []
          : [
              {
                label: "Cancel",
                variant: "cancel",
                onClick: handleClose,
              },
            ]
      }
      dataTestId="recording-modal"
    >
      <div className="pb-4">
        <h5 className="text-secondary text-xs md:text-sm">
          Click to record follow-up audio. We&#39;ll add it to the
          original recording and reprocess your note. Please note that
          edits to the original note will be lost.
        </h5>
        <Record
          isRecording={isRecording}
          setIsRecording={setIsRecording}
          control={control}
          getValues={getValues}
          createNewNote={appendRecordingToNote}
          shouldShowTitleInput={false}
          shouldUseSmallSize={true}
          shouldShowTypeDropdown={false}
          shouldShowRecordAs={false}
          shouldDisableCallMode={false}
          appendToNoteUuid={noteUuid}
        />
      </div>
    </DSModal>
  );
}
